import React from "react";
import styled from "styled-components";

import { RouterLink } from "@examspark/common-ui";
import { IconPageNextLine } from "@examspark/common-ui/dist/components/icons";
import { getKeyForReactNode } from "@examspark/common-ui/dist/utils/react";

const Styled = styled.ul`
  margin: 0;
  padding: 0;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 0.7rem;

  align-content: center;

  svg {
    fill: #888;
  }

  a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`;

const Breadcrumbs = (props: { items: React.ReactNode[] }) => {
  return (
    <Styled>
      {props.items.map((item, index) => {
        if (!item) return null;

        return (
          <React.Fragment key={getKeyForReactNode(item) ?? index}>
            {item}
            <IconPageNextLine title="Right Arrow" width="10" />
          </React.Fragment>
        );
      })}
    </Styled>
  );
};

Breadcrumbs.Dashboard = () => [
  <RouterLink key="dashboard" to="/">
    Dashboard
  </RouterLink>,
];

Breadcrumbs.Browse = () => [
  ...Breadcrumbs.Dashboard(),
  <RouterLink key="browse" to="/browse">
    Browse
  </RouterLink>,
];

Breadcrumbs.Classroom = (classroom?: {
  id?: string | null;
  name?: string | null;
}) => [
  ...Breadcrumbs.Dashboard(),
  <RouterLink key="classrooms" to="/classrooms">
    Classrooms
  </RouterLink>,
  classroom?.id != null && (
    <RouterLink key="classroom" to={`/classrooms/${classroom.id}`}>
      {classroom.name}
    </RouterLink>
  ),
];

export default Breadcrumbs;
